import clsx from 'clsx'
import React, {forwardRef} from 'react'

import {PropsWithClasses} from '../theme/UNSTABLE_makeStyles'
import {ClassKey, useClasses} from './Link.classes'

type AnchorProps = JSX.IntrinsicElements['a']

export type LinkProps = PropsWithClasses<ClassKey> &
  AnchorProps & {
    icon?: React.ReactNode
    disabled?: boolean
    newTab?: boolean
  }

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props: LinkProps, ref) => {
  const {icon, newTab = false, rel, disabled, children, className, classes: classesProp, ...anchorProps} = props
  const newTabProps = newTab ? {target: '_blank', rel: ['noopener noreferrer', rel].filter(Boolean).join(' ')} : {}
  const classes = useClasses(classesProp)

  return (
    <a
      ref={ref}
      className={clsx(classes.root, disabled && classes.disabled, className)}
      {...anchorProps}
      {...newTabProps}
    >
      {!!icon && <span className={classes.icon}>{icon}</span>}
      {children}
    </a>
  )
})
